import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Dallas" />

        <footer>
          This project was coded by{" "}
          <a
            href="https://teal-quokka-bb6196.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Chelsea Campbell
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/chelseacampbell22/weather-react"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://earnest-semolina-95e511.netlify.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}
